import Layout from '../../components/feature/Layout';
import ProductsHero from './components/ProductsHero';
import ProductsOverviewSection from './components/ProductsOverviewSection';
import ProductsLifecycleSection from './components/ProductsLifecycleSection';

export default function ProductsPage() {
  return (
    <Layout>
      <ProductsHero />
      <ProductsOverviewSection />
      <ProductsLifecycleSection />
    </Layout>
  );
}
